import qs from 'qs'
import {format} from 'utils'
import request from 'crm/utils/request'
import api from 'crm/common/api/tag-create-group'

export async function tasks(payload) {
    return request(`${format(api.tasks.url)}?${qs.stringify(payload)}`)
}

// 新建
export async function create(payload) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload.body,
    })
}

// 获取客户管理的客户
export async function customerCount(payload) {
    return request(api.customerCount.url, {
        method: api.customerCount.type,
        body: payload.body,
    })
}

// 过滤后的客户数量
export async function filterCustomerCount(payload) {
    return request(api.filterCustomerCount.url, {
        method: api.filterCustomerCount.type,
        body: payload.body,
    })
}

export async function remindUser(payload) {
    return request(format(api.remindUser.url, {id: payload.id}), {
        method: api.remindUser.type,
        body: payload.body,
    })
}

export async function taskGroupChat(payload) {
    return request(
        `${format(api.taskGroupChat.url, {id: payload.id})}?${qs.stringify(payload.params)}`,
    )
}

export async function updateTaskGroupChat(payload) {
    return request(format(api.updateTaskGroupChat.url, {id: payload.id}), {
        method: api.updateTaskGroupChat.type,
        body: payload.body,
    })
}

export async function removeTaskGroupChat(payload) {
    return request(
        format(api.removeTaskGroupChat.url, {id: payload.id, group_chat_id: payload.group_chat_id}),
        {
            method: api.removeTaskGroupChat.type,
        },
    )
}

export async function taskDetail(payload) {
    return request(format(api.taskDetail.url, {id: payload.id}))
}

export async function taskSummary(payload) {
    return request(format(api.taskSummary.url, {id: payload.id}))
}

export async function detailListByCustomer(payload) {
    return request(
        `${format(api.detailListByCustomer.url, {id: payload.id})}?${qs.stringify(payload.params)}`,
    )
}

export async function detailListByUser(payload) {
    return request(
        `${format(api.detailListByUser.url, {id: payload.id})}?${qs.stringify(payload.params)}`,
    )
}
